<h2 matDialogTitle>
  {{dialogTitle}}
</h2>

<mat-dialog-content>
    <mgd-dialog-content-container>
      <form #mgdEnhancedForm="mgdEnhancedForm" mgdEnhancedForm [formGroup]="formGroup" class="support-request" (ngSubmit)="onNgSubmit()">

      <mat-form-field class="mat-summary-field" id="mat-summary-field">
        <mat-label>Summary</mat-label>
        <input mgdClearInput matInput formControlName="summary" class="summary" required mgdEnhancedControl #summaryControl="mgdEnhancedControl" />
        <mgd-clear-button matSuffix [formField]="summaryControl" />
        <mat-error><mgd-error-message [formField]="summaryControl" /></mat-error>
      </mat-form-field>

      <mat-form-field class="mat-description-field" id="mat-description-field">
        <mat-label>Description</mat-label>
        <textarea mgdClearInput matInput formControlName="description" class="description" placeholder="Description" required
        cdkTextareaAutosize cdkAutosizeMinRows="15" cdkAutosizeMaxRows="15" mgdEnhancedControl #descriptionControl="mgdEnhancedControl" ></textarea>
        <mgd-clear-button matSuffix [formField]="descriptionControl" />
        <mat-error><mgd-error-message [formField]="descriptionControl" /></mat-error>
      </mat-form-field>

      <mat-form-field class="mat-urgency-field" id="mat-urgency-field">
        <mat-label>Urgency</mat-label>
        <mat-select id="mat-urgency-select" formControlName="urgency" required mgdEnhancedControl #urgencyControl="mgdEnhancedControl" [matTooltip]="urgencyTooltips[formGroup.controls.urgency.value]">
          @for (option of urgencies; track option) {
            <mat-option [value]="option" [matTooltip]="urgencyTooltips[option]">
              {{ option | mgdEnumDisplay:SupportRequestUrgency }}
            </mat-option>
          }
        </mat-select>
        <mat-error><mgd-error-message [formField]="urgencyControl" /></mat-error>
      </mat-form-field>
    </form>
  </mgd-dialog-content-container>
</mat-dialog-content>

<mat-dialog-actions>
  <button mgdDialogCloseButton mat-raised-button type="button">
    Cancel
  </button>

  <button id="mat-submit-button" type="button" mgdButton mgdButtonType="save" [enhancedForm]="mgdEnhancedForm" mat-raised-button (click)="onSubmitClick()">
    Submit
  </button>
</mat-dialog-actions>